import {
  INVESTOR_CODE_REGEX,
} from '../../../../financial-statement/modals/capital-account/manage-investors-modal/manage-investors-modal.component';

export const extractHeaders = (data: any[]): string[] => Object.keys(data[0]);

/**
 * This method is very specific to how the data is structured after Capital Account Excel import.
 * The aim is to obtain FS Items, where Allocation type is 'Manual', as only those values are allowed to be modified
 * after the Excel import.
 */
export const filterManualColumns = (data: any[]): string[] => {
  const headers = extractHeaders(data);
  return headers.filter((header) => data[0][header] === 'Manual');
};

/**
 * This method is very specific to how the data is structured after Capital Account Excel import.
 * The aim is to obtain rows with actual investors' values, filtering out headers, totals and the rest of the stuff,
 * which is done by verifying whether the actual ID(investor code) is stored in IDs column.
 */
export const filterInvestorData = (data: any[]): any[] => data.slice(1)
  .filter((row) => INVESTOR_CODE_REGEX.test(row.ID));

export const parseItemManualValuesFromExcel = (investorsExcelData: any[]): ItemManualValueData[] => {
  const manualColumns = filterManualColumns(investorsExcelData);
  const investorData = filterInvestorData(investorsExcelData);
  const itemManualValueData: ItemManualValueData[] = [];

  investorData.forEach((investorRow) => {
    manualColumns.forEach((itemName) => {
      const item = findOrAddNewItem(itemName, itemManualValueData);
      item.investorValues.push({ investorCode: investorRow.ID, itemManualValue: investorRow[itemName] });
    });
  });

  return itemManualValueData;
};

const findOrAddNewItem = (itemName: string, itemManualValueData: ItemManualValueData[]): ItemManualValueData => {
  let itemManualValue = itemManualValueData.find((item) => item.itemName === itemName);
  if (!itemManualValue) {
    itemManualValue = { itemName, investorValues: [] };
    itemManualValueData.push(itemManualValue);
  }
  return itemManualValue;
};

export interface ItemManualValueData {
  itemName: string;
  investorValues: InvestorItemManualValue[];
}

export interface InvestorItemManualValue {
  investorCode: string;
  itemManualValue: number | undefined;
}
